import { useContext } from "react";
import { ReactComponent as Logo } from "../../assets/images/starting-finance-minimized.svg"
import Button from "../Button"
import style from "./Footer.module.css"
import MainContext from "../../common/MainContext";

const Footer = () => {
    const context = useContext(MainContext);

    return (
        <div className={style.container}>
            <div className={style.info}>
                <Logo className={style.logo} />
                <div className={style.company}>
                    <div className={style.copyright}>Copyright ©2025 Starting Finance SRL</div>
                    <div className={style.vatNumber}>Partita IVA: 14944641001</div>
                </div>
            </div>
            <div className={style.info}>
                <div className={style.company}>
                    <div className={style.appVersion}>Version: {context.appVersion}</div>
                </div>
            </div>
            <div className={style.links}>
                <Button appearance="text" onClick={() => {
                    window.open('mailto:education@startingfinance.com')
                }}> Contatti </Button>
                <Button appearance="text" onClick={() => {
                    window.open('https://startingfinance.com/privacy-policy')
                }}>Cookie Policy</Button>
            </div>
        </div>
    )
}

export default Footer
